export const MAX_ARTICLE_IMAGE_SIZE = 5 * 1024 * 1024;

export function validateArticleImageFiles(
  files: ReadonlyArray<{ name: string; size: number }>
): string | null {
  const oversized = files.find((file) => file.size > MAX_ARTICLE_IMAGE_SIZE);
  return oversized
    ? `${oversized.name}: File size exceeds the maximum allowed: 5 Mb`
    : null;
}
